'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Layout = undefined;

var _isArray = require('d2-utilizr/lib/isArray');

var _isArray2 = _interopRequireDefault(_isArray);

var _isBoolean = require('d2-utilizr/lib/isBoolean');

var _isBoolean2 = _interopRequireDefault(_isBoolean);

var _isDefined = require('d2-utilizr/lib/isDefined');

var _isDefined2 = _interopRequireDefault(_isDefined);

var _isNumber = require('d2-utilizr/lib/isNumber');

var _isNumber2 = _interopRequireDefault(_isNumber);

var _isObject = require('d2-utilizr/lib/isObject');

var _isObject2 = _interopRequireDefault(_isObject);

var _isString = require('d2-utilizr/lib/isString');

var _isString2 = _interopRequireDefault(_isString);

var _arrayClean = require('d2-utilizr/lib/arrayClean');

var _arrayClean2 = _interopRequireDefault(_arrayClean);

var _arrayContains = require('d2-utilizr/lib/arrayContains');

var _arrayContains2 = _interopRequireDefault(_arrayContains);

var _arrayFrom = require('d2-utilizr/lib/arrayFrom');

var _arrayFrom2 = _interopRequireDefault(_arrayFrom);

var _arrayPluck = require('d2-utilizr/lib/arrayPluck');

var _arrayPluck2 = _interopRequireDefault(_arrayPluck);

var _arraySort = require('d2-utilizr/lib/arraySort');

var _arraySort2 = _interopRequireDefault(_arraySort);

var _DateManager = require('../manager/DateManager.js');

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Layout = exports.Layout = undefined;

exports.Layout = Layout = function Layout(refs, c, applyConfig, forceApplyConfig) {
    var t = this;

    refs = (0, _isObject2.default)(refs) ? refs : {};

    var _refs$api = refs.api,
        Axis = _refs$api.Axis,
        Sorting = _refs$api.Sorting;


    c = (0, _isObject2.default)(c) ? c : {};
    $.extend(c, applyConfig);

    // private
    var _path = refs.appManager.getApiPath();
    var _source = '/analytics';
    var _format = 'json';

    var _response;
    var _access;

    var _dataDimensionItems;

    // constructor
    t.columns = Axis(refs, c.columns).val(true);
    t.rows = Axis(refs, c.rows).val(true);
    t.filters = Axis(refs, c.filters).val(true);

    // access
    _access = (0, _isObject2.default)(c.access) ? c.access : null;

    // data dimension items
    _dataDimensionItems = (0, _isArray2.default)(c.dataDimensionItems) ? c.dataDimensionItems : null;

    // non model

    // id
    if ((0, _isString2.default)(c.id)) {
        t.id = c.id;
    }

    // interpretationId
    if ((0, _isString2.default)(c.interpretationId)) {
        t.interpretationId = c.interpretationId;
    }

    // DHIS2-2784: propagate both name and displayName
    // to avoid name being replaced by a translation in the translate dialog
    // name
    if ((0, _isString2.default)(c.name)) {
        t.name = c.name;
    }

    t.displayName = (0, _arrayClean2.default)([c.displayName, c.displayShortName, c.name, c.shortName]).find(function (item) {
        return (0, _isString2.default)(item);
    });

    // title
    t.title = (0, _arrayClean2.default)([c.displayShortName, c.title]).find(function (item) {
        return (0, _isString2.default)(item);
    });

    // description
    if ((0, _isString2.default)(c.description)) {
        t.description = c.description;
    }

    // sorting
    if ((0, _isObject2.default)(c.sorting) && (0, _isDefined2.default)(c.sorting.id) && (0, _isString2.default)(c.sorting.direction)) {
        t.sorting = new Sorting(refs, c.sorting);
    }

    // displayProperty
    if ((0, _isString2.default)(c.displayProperty)) {
        t.displayProperty = c.displayProperty;
    }

    // userOrgUnit
    if ((0, _arrayFrom2.default)(c.userOrgUnit).length) {
        t.userOrgUnit = (0, _arrayFrom2.default)(c.userOrgUnit);
    }

    // startDate
    if ((0, _isString2.default)(c.startDate)) {
        t.startDate = c.startDate;
    }

    // endDate
    if ((0, _isString2.default)(c.endDate)) {
        t.endDate = c.endDate;
    }

    // relative period date
    if (_DateManager.DateManager.getYYYYMMDD(c.relativePeriodDate)) {
        t.relativePeriodDate = _DateManager.DateManager.getYYYYMMDD(c.relativePeriodDate);
    }

    //description
    if ((0, _isString2.default)(c.displayDescription)) {
        t.displayDescription = c.displayDescription;
    }

    //interpretations
    if ((0, _arrayFrom2.default)(c.interpretations).length) {
        t.interpretations = (0, _isArray2.default)(c.interpretations) ? c.interpretations : null;
    }

    //lastUpdated
    if (_DateManager.DateManager.getYYYYMMDD(c.lastUpdated)) {
        t.lastUpdated = _DateManager.DateManager.getYYYYMMDD(c.lastUpdated);
    }

    //created
    if (_DateManager.DateManager.getYYYYMMDD(c.created)) {
        t.created = _DateManager.DateManager.getYYYYMMDD(c.created);
    }

    //favorite user
    if ((0, _isObject2.default)(c.user)) {
        t.user = c.user;
    }

    //public access
    if ((0, _isString2.default)(c.publicAccess)) {
        t.publicAccess = c.publicAccess;
    }

    //permission
    if ((0, _isString2.default)(c.permission)) {
        t.permission = c.permission;
    }

    //user group accesses
    if ((0, _arrayFrom2.default)(c.userGroupAccesses).length) {
        t.userGroupAccesses = c.userGroupAccesses;
    }

    if (c.el && (0, _isString2.default)(c.el)) {
        t.el = c.el;
    }

    // translations
    if ((0, _arrayFrom2.default)(c.translations).length) {
        t.translations = c.translations;
    }

    $.extend(t, forceApplyConfig);

    // setter/getter
    t.getResponse = function () {
        return _response;
    };

    t.setResponse = function (r) {
        _response = r;
    };

    t.getAccess = function () {
        return _access;
    };

    t.setAccess = function (a) {
        _access = a;
    };

    t.getDataDimensionItems = function () {
        return _dataDimensionItems;
    };

    t.setDataDimensionItems = function (a) {
        _dataDimensionItems = a;
    };

    t.getDefaultPath = function () {
        return _path;
    };

    t.getDefaultSource = function () {
        return _source;
    };

    t.getDefaultFormat = function () {
        return _format;
    };

    t.getRequestPath = function (s, f) {
        return (_path || refs.appManager.getPath()) + (s || _source) + '.' + (f || _format);
    };

    t.getRefs = function () {
        return refs;
    };
};

Layout.prototype.log = function (text, noError) {
    if (!noError) {
        console.log(text, this);
    }
};

Layout.prototype.alert = function (text, noError) {
    if (!noError) {
        alert(text);
    }
};

Layout.prototype.apply = function (obj, keys) {
    var t = this;

    if (!(0, _isObject2.default)(obj)) {
        return t;
    }

    var preservedProps = ['name', 'description'];

    keys = (0, _isArray2.default)(keys) ? keys : preservedProps;

    keys.forEach(function (key) {
        t[key] = obj[key];
    });

    return t;
};

Layout.prototype.toRows = function (includeFilter) {
    this.rows = (0, _arrayClean2.default)(this.rows.concat(this.columns.empty(), includeFilter ? this.filters.empty() : []));
};

Layout.prototype.getAxes = function (includeFilter) {
    return (0, _arrayClean2.default)([this.columns, this.rows, includeFilter ? this.filters : null]);
};

Layout.prototype.getUserOrgUnitUrl = function () {
    if ((0, _isArray2.default)(this.userOrgUnit) && this.userOrgUnit.length) {
        return 'userOrgUnit=' + this.userOrgUnit.join(';');
    }
};

Layout.prototype.applyInterpretation = function (interpretation) {
    this.setResponse(null);
    this.relativePeriodDate = interpretation.created;
    this.interpretationId = interpretation.id;
};

Layout.prototype.setSharing = function (sharing) {
    this.publicAccess = sharing.publicAccess;
    this.externalAccess = sharing.externalAccess;
    this.userGroupAccesses = sharing.userGroupAccesses;
    this.userAccesses = sharing.userAccesses;
};

// dep 1

Layout.prototype.hasDimension = function (dimensionName, includeFilter) {
    return this.getAxes(includeFilter).some(function (axis) {
        return axis.has(dimensionName);
    });
};

Layout.prototype.getDimensions = function (includeFilter, isSorted, axes) {
    var dimensions = [];

    axes = (0, _arrayClean2.default)(axes ? (0, _arrayFrom2.default)(axes) : this.getAxes(includeFilter));

    axes.forEach(function (axis) {
        dimensions = dimensions.concat(axis);
    });

    return isSorted ? dimensions.sort(function (a, b) {
        return a.dimension > b.dimension;
    }) : dimensions;
};

Layout.prototype.getRecords = function (includeFilter, response) {
    var t = this;

    var records = [];

    this.getAxes(includeFilter).forEach(function (axis) {
        axis.forEach(function (dimension) {
            records = records.concat(dimension.getRecords(null, response));
        });
    });

    return records;
};

Layout.prototype.extendRecords = function (response) {
    this.getAxes(true).forEach(function (axis) {
        axis.extendRecords(response);
    });
};

Layout.prototype.stripAxes = function (includeFilter, skipAddToFilter) {
    var t = this,
        refs = t.getRefs();

    var Axis = refs.api.Axis;


    if (!skipAddToFilter && !t.filters) {
        t.filters = new Axis(refs);
    }

    t.getAxes(includeFilter).forEach(function (axis) {
        axis.strip().forEach(function (dimension) {
            if (!skipAddToFilter) {
                t.filters.add(dimension);
            }
        });
    });
};

Layout.prototype.replaceDimensionByName = function (dimension, includeFilter) {
    this.getAxes(includeFilter).forEach(function (axis) {
        if (axis.has(dimension.dimension)) {
            axis.replaceDimensionByName(dimension);
        }
    });
};

// dep 2

Layout.prototype.getRecordIds = function (includeFilter) {
    var ids = [];

    this.getRecords(includeFilter).forEach(function (record) {
        ids.push(record.id);
    });

    return ids;
};

Layout.prototype.getDimension = function (dimensionName) {
    return this.getDimensions(true).find(function (dimension) {
        return dimension.dimension === dimensionName;
    });
};

Layout.prototype.getDimensionNames = function (includeFilter, isSorted, axes) {
    var names = (0, _arrayPluck2.default)(this.getDimensions(includeFilter, false, axes), 'dimension');

    return isSorted ? names.sort() : names;
};

Layout.prototype.getDimensionNameIdsMap = function (response) {
    var map = {};

    response = response || this.getResponse();

    this.getDimensions(true).forEach(function (dimension) {
        map[dimension.dimension] = dimension.getRecordIds(false, response);
    });

    return map;
};

Layout.prototype.removeDimensionItems = function (includeFilter) {
    this.getDimensions(includeFilter).forEach(function (dimension) {
        dimension.removeItems();
    });
};

Layout.prototype.val = function (noError) {
    var refs = this.getRefs();
    var i18nManager = refs.i18nManager;

    if (!(this.columns || this.rows)) {
        this.alert(i18nManager.get('at_least_one_dimension_must_be_specified_as_row_or_column'), noError); //todo alert
        return null;
    }

    if (!this.hasDimension(refs.dimensionConfig.get('period').dimensionName, true)) {
        this.alert(i18nManager.get('at_least_one_period_must_be_specified_as_column_row_or_filter'), noError); //todo alert
        return null;
    }

    return this;
};

Layout.prototype.toPlugin = function (el) {
    var t = this,
        refs = this.getRefs();

    var appManager = refs.appManager,
        optionConfig = refs.optionConfig,
        layout;

    if (t.id) {
        layout = {
            id: t.id
        };
    } else {
        layout = t.clone();

        // columns, rows, filters
        layout.getAxes(true).forEach(function (item) {
            item.toPlugin();
        });

        // properties
        var deleteIfTruthy = ['showRowTotals', 'showColTotals', 'showColSubTotals', 'showRowSubTotals', 'showDimensionLabels', 'showValues'];

        var deleteIfFalsy = ['hideEmptyRows', 'hideEmptyColumns', 'stickyColumnDimension', 'stickyRowDimension', 'skipRounding', 'showHierarchy', 'completedOnly', 'hideLegend', 'hideTitle', 'title', 'legendSet', 'sorting', 'targetLineValue', 'targetLineTitle', 'baseLineValue', 'baseLineTitle', 'rangeAxisMaxValue', 'rangeAxisMinValue', 'rangeAxisSteps', 'rangeAxisDecimals', 'rangeAxisTitle', 'domainAxisTitle', 'regression', 'cumulative', 'sortOrder', 'topLimit'];

        var deleteAnyway = ['klass', 'name', 'parentGraphMap', 'reportingPeriod', 'organisationUnit', 'parentOrganisationUnit', 'cumulative', 'sortOrder', 'topLimit', 'displayDescription', 'displayName', 'interpretations', 'lastUpdated', 'created', 'user', 'publicAccess', 'permission', 'userGroupAccesses', 'prototype', 'url'];

        deleteIfTruthy.forEach(function (item) {
            if (!!layout[item]) {
                delete layout[item];
            }
        });

        deleteIfFalsy.forEach(function (item) {
            if (!layout[item]) {
                delete layout[item];
            }
        });

        deleteAnyway.forEach(function (item) {
            delete layout[item];
        });

        if (layout.displayDensity === optionConfig.getDisplayDensity('normal').id) {
            delete layout.displayDensity;
        }

        if (layout.fontSize === optionConfig.getFontSize('normal').id) {
            delete layout.fontSize;
        }

        if (layout.digitGroupSeparator === optionConfig.getDigitGroupSeparator('space').id) {
            delete layout.digitGroupSeparator;
        }

        if (layout.aggregationType === optionConfig.getAggregationType('def').id) {
            delete layout.aggregationType;
        }

        if (layout.numberType === optionConfig.getNumberType('value').id) {
            delete layout.numberType;
        }

        if (layout.dataApprovalLevel && layout.dataApprovalLevel.id === optionConfig.getDataApprovalLevel('def').id) {
            delete layout.dataApprovalLevel;
        }

        if (layout.regressionType === 'NONE') {
            delete layout.regressionType;
        }
    }

    layout.url = appManager.getPath();

    if (el) {
        layout.el = el;
    }

    return layout;
};

Layout.prototype.toPostSuper = function () {
    delete this.klass;
    delete this.getResponse;
    delete this.setResponse;
    delete this.getAccess;
    delete this.setAccess;
    delete this.getDataDimensionItems;
    delete this.setDataDimensionItems;
    delete this.getRequestPath;

    this.getDimensions(true).forEach(function (dimension) {
        dimension.toPost();
    });

    this.rowTotals = this.showRowTotals;
    delete this.showRowTotals;

    this.colTotals = this.showColTotals;
    delete this.showColTotals;

    this.rowSubTotals = this.showRowSubTotals;
    delete this.showRowSubTotals;

    this.colSubTotals = this.showColSubTotals;
    delete this.showColSubTotals;

    this.reportParams = {
        paramReportingPeriod: this.reportingPeriod,
        paramOrganisationUnit: this.organisationUnit,
        paramParentOrganisationUnit: this.parentOrganisationUnit
    };

    delete this.reportingPeriod;
    delete this.organisationUnit;
    delete this.parentOrganisationUnit;

    delete this.parentGraphMap;

    delete this.id;
    delete this.el;

    delete this.displayDescription;
    delete this.interpretations;
    delete this.lastUpdated;
    delete this.created;
    delete this.user;
    delete this.publicAccess;
    delete this.permission, delete this.userGroupAccesses;
    delete this.displayName;
};

Layout.prototype.toSession = function () {
    var t = this;

    var response = t.getResponse();

    t.extendRecords(response);

    return t;
};

Layout.prototype.sort = function (table) {
    var t = this,
        refs = t.getRefs();

    var _refs$api2 = refs.api,
        Record = _refs$api2.Record,
        Dimension = _refs$api2.Dimension,
        ResponseRowIdCombination = _refs$api2.ResponseRowIdCombination;


    var id = this.sorting.id,
        direction = this.sorting.direction,
        dimension = this.rows[0],
        response = this.getResponse(),
        idValueMap = table ? table.idValueMap : response.getIdValueMap(t),
        records = [],
        ids,
        sortingId,
        obj;

    if (!(0, _isString2.default)(id)) {
        return;
    }

    ids = this.getDimensionNameIdsMap(response)[dimension.dimension];

    ids.forEach(function (item) {
        var validId = new ResponseRowIdCombination(refs, [id, item]).get();
        sortingId = parseFloat(idValueMap[validId]);

        obj = {
            id: item,
            sortingId: (0, _isNumber2.default)(sortingId) ? sortingId : Number.MAX_VALUE * -1
        };

        records.push(obj);
    });

    // sort
    (0, _arraySort2.default)(records, direction, 'sortingId');

    // dimension
    dimension.items = records.map(function (record) {
        return new Record(refs, record);
    });
    dimension.sorted = true;

    this.sorting.id = id;
};

// dep 3

Layout.prototype.hasRecordIds = function (idParam, includeFilter) {
    var ids = this.getRecordIds(includeFilter);
    var has = false;

    idParam = (0, _arrayFrom2.default)(idParam);

    idParam.forEach(function (id) {
        if ((0, _arrayContains2.default)(ids, id)) {
            has = true;
        }
    });

    return has;
};

Layout.prototype.getFirstDxId = function () {
    return this.getDimension('dx').getRecordIds()[0];
};

Layout.prototype.del = function (fn, doMask, doUnmask) {
    var t = this,
        refs = this.getRefs();

    var instanceManager = refs.instanceManager;

    instanceManager.delById(t.id, fn, doMask, doUnmask);
};

Layout.prototype.toPost = function () {
    var t = this;

    t.toPostSuper();
};

Layout.prototype.isDimensionInRows = function (dimensionName) {
    return this.rows.getDimensionNames().indexOf(dimensionName) !== -1;
};

// dep 4

Layout.prototype.toPut = function () {
    this.toPost();
};

Layout.prototype.isPeriodInRows = function () {
    return this.isDimensionInRows('pe');
};

Layout.prototype.isOrganisationUnitInRows = function () {
    return this.isDimensionInRows('ou');
};

// dep 5

Layout.prototype.post = function (fn, doMask, doUnmask) {
    var t = this,
        refs = this.getRefs();

    var appManager = refs.appManager,
        instanceManager = refs.instanceManager,
        uiManager = refs.uiManager;

    var apiPath = appManager.getApiPath(),
        apiEndpoint = instanceManager.apiEndpoint;

    var url = apiPath + '/' + apiEndpoint;

    if (doMask) {
        uiManager.mask();
    }

    // "Save as" mode, t.id is present, copy settings from original
    if (t.id) {
        instanceManager.getSharingById(t.id, function (sharing) {
            // set sharing
            if ((0, _isObject2.default)(sharing) && (0, _isObject2.default)(sharing.object)) {
                t.setSharing(sharing.object);
            }
        });
    }

    t.toPost();

    // post
    var postRequest = new refs.api.Request(refs, {
        baseUrl: url,
        type: 'ajax',
        method: 'POST',
        data: JSON.stringify(t),
        success: function success(obj, _success, r) {
            var id = (r.getResponseHeader('location') || '').split('/').pop();

            if (!(0, _isString2.default)(id)) {
                console.log('Layout post', 'Invalid id', id);
            }

            if (doUnmask) {
                uiManager.unmask();
            }

            if (fn) {
                fn(id, _success, r);
            }
        }
    });

    postRequest.run();
    //    });
};

Layout.prototype.put = function (id, fn, doMask, doUnmask) {
    var t = this,
        refs = this.getRefs();

    var appManager = refs.appManager,
        instanceManager = refs.instanceManager,
        uiManager = refs.uiManager;

    var apiPath = appManager.getApiPath(),
        apiEndpoint = instanceManager.apiEndpoint;

    var url = apiPath + '/' + apiEndpoint + '/' + id;

    if (doMask) {
        uiManager.mask();
    }

    instanceManager.getSharingById(t.id, function (sharing) {
        t.toPut();

        // set sharing
        if ((0, _isObject2.default)(sharing) && (0, _isObject2.default)(sharing.object)) {
            t.setSharing(sharing.object);
        }

        // put
        var putRequest = new refs.api.Request(refs, {
            baseUrl: url,
            type: 'ajax',
            method: 'PUT',
            data: JSON.stringify(t),
            success: function success(obj, _success2, r) {
                if (doUnmask) {
                    uiManager.unmask();
                }

                if (fn) {
                    fn(id, _success2, r);
                }
            },
            error: function error(r) {
                if ((0, _arrayContains2.default)([403], parseInt(r.httpStatusCode))) {
                    r.message = i18n.you_do_not_have_access_to_all_items_in_this_favorite || r.message;
                }

                if (doMask) {
                    uiManager.unmask();
                }

                uiManager.alert(r);
            }
        });

        putRequest.run();
    });
};

Layout.prototype.patch = function (properties, fn, doMask, doUnmask) {
    var t = this,
        refs = this.getRefs();

    var appManager = refs.appManager,
        instanceManager = refs.instanceManager,
        uiManager = refs.uiManager;

    var apiPath = appManager.getApiPath(),
        apiEndpoint = instanceManager.apiEndpoint;

    var url = apiPath + '/' + apiEndpoint + '/' + t.id;

    if (!(0, _isObject2.default)(properties)) {
        return;
    }

    if (doMask) {
        uiManager.mask();
    }

    var patchRequest = new refs.api.Request(refs, {
        baseUrl: url,
        type: 'ajax',
        method: 'PATCH',
        data: JSON.stringify(properties),
        dataType: 'text',
        headers: appManager.defaultRequestHeaders,
        success: function success(obj, _success3, r) {
            if (doUnmask) {
                uiManager.unmask();
            }

            if (fn) {
                fn(null, _success3, r);
            }
        }
    });

    patchRequest.run();
};

Layout.prototype.req = function (source, format, isSorted, isTableLayout, isFilterAsDimension) {
    var t = this,
        refs = this.getRefs();

    var Request = refs.api.Request;


    var optionConfig = refs.optionConfig,
        appManager = refs.appManager,
        request = new Request(refs);

    var defAggTypeId = optionConfig.getAggregationType('def').id,
        displayProperty = this.displayProperty || appManager.getAnalyticsDisplayProperty();

    // dimensions
    this.getDimensions(false, isSorted).forEach(function (dimension) {
        request.add(dimension.url(isSorted));
    });

    // filters
    if (this.filters) {
        this.filters.forEach(function (dimension) {
            var isFilter = !(isFilterAsDimension && dimension.isRequired());

            request.add(dimension.url(isSorted, null, isFilter));
        });
    }

    // skip rounding
    if (this.skipRounding) {
        request.add('skipRounding=true');
    }

    // display property
    request.add('displayProperty=' + displayProperty.toUpperCase());

    // completed only
    if (this.completedOnly) {
        request.add('completedOnly=true');
    }

    // normal request only
    if (!isTableLayout) {
        // hierarchy
        if (this.showHierarchy) {
            request.add('hierarchyMeta=true');
        }

        // aggregation type
        if ((0, _isString2.default)(this.aggregationType) && this.aggregationType !== defAggTypeId) {
            request.add('aggregationType=' + this.aggregationType);
        }

        // user org unit
        if ((0, _isArray2.default)(this.userOrgUnit) && this.userOrgUnit.length) {
            request.add(this.getUserOrgUnitUrl());
        }

        // data approval level
        if ((0, _isObject2.default)(this.dataApprovalLevel) && (0, _isString2.default)(this.dataApprovalLevel.id) && this.dataApprovalLevel.id !== 'DEFAULT') {
            request.add('approvalLevel=' + this.dataApprovalLevel.id);
        }

        // relative period date
        if (this.relativePeriodDate) {
            request.add('relativePeriodDate=' + this.relativePeriodDate);
        }

        // measure criteria
        if (this.measureCriteria) {
            request.add('measureCriteria=' + this.measureCriteria);
        }
    } else {
        // table layout
        request.add('tableLayout=true');

        // columns
        request.add('columns=' + this.getDimensionNames(false, false, this.columns).join(';'));

        // rows
        request.add('rows=' + this.getDimensionNames(false, false, this.rows).join(';'));

        // hide empty columns
        if (this.hideEmptyColumns) {
            request.add('hideEmptyColumns=true');
        }

        // hide empty rows
        if (this.hideEmptyRows) {
            request.add('hideEmptyRows=true');
        }

        // show hierarchy
        if (this.showHierarchy) {
            request.add('showHierarchy=true');
        }
    }

    // relative orgunits / user
    if (this.hasRecordIds(appManager.userIdDestroyCacheKeys, true)) {
        request.add('user=' + appManager.userAccount.id);
    }

    // base
    request.setBaseUrl(this.getRequestPath(source, format));

    return request;
};

// dep 5

Layout.prototype.data = function (source, format) {
    var t = this,
        refs = this.getRefs();

    var uiManager = refs.uiManager;

    var metaDataRequest = this.req(source, format);
    var dataRequest = this.req(source, format, true);

    var errorFn = function errorFn(r) {
        // 409
        // DHIS2-2020: 503 error (perhaps analytics maintenance mode)
        if ((0, _isObject2.default)(r) && (r.status == 409 || r.status === 503)) {
            uiManager.unmask();

            if ((0, _isString2.default)(r.responseText)) {
                uiManager.alert(JSON.parse(r.responseText));
            }
        }
    };

    metaDataRequest.setType(this.getDefaultFormat());
    dataRequest.setType(this.getDefaultFormat());

    metaDataRequest.add('skipData=true');
    dataRequest.add('skipMeta=true');

    metaDataRequest.add('includeMetadataDetails=true');
    dataRequest.add('includeNumDen=true');

    metaDataRequest.setError(errorFn);
    dataRequest.setError(errorFn);

    return {
        metaData: metaDataRequest.run(),
        data: dataRequest.run()
    };
};
//# sourceMappingURL=Layout.js.map


/*****************
 ** WEBPACK FOOTER
 ** ./~/d2-analysis/lib/api/Layout.js
 ** module id = 111
 ** module chunks = 0 1
 **/